import "./assets/js/app"; // メインJS
import "./assets/sass/app.scss"; // メインCSS

const elm = document.getElementById('sp2024');
document.getElementById('toggleBtn').addEventListener('click',() => {
    // 要素が既に新しいクラスを持っているかどうかをチェック
    if (elm.classList.contains('baseFP')) {
    // 新しいクラスが既にある場合は、古いクラスに切り替え
    elm.classList.remove('baseFP');
    elm.classList.add('baseGK');
    } else {
    // 新しいクラスがない場合は、新しいクラスに切り替え
    elm.classList.remove('baseGK');
    elm.classList.add('baseFP');
    }
});


function className(entries) {
    entries.forEach( entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add("active");
            
        // } else {
        //     entry.target.classList.remove("active");
        }
    });
}

const transition = document.querySelectorAll('.trans');
const options = {
    root: null,
    rootMargin: "0px 0px -10%",
    threshold: 0
};

const observer = new IntersectionObserver(className,options);
transition.forEach(trans => {
    observer.observe(trans);
});

const btn = document.getElementById('toggleBtn');
const btnArea = document.getElementById('btnArea');

function doWhenMvIntersect(entries) {
    entries.forEach(entry => {
        if (entry.isIntersecting ) {
        btn.classList.add('active');
        } else {
        btn.classList.remove('active');
        }
    });
}

const btnOptions = {
    root: null, 
    rootMargin: "0px 0px -15%",
    threshold: 0
};

const btnObserver = new IntersectionObserver(doWhenMvIntersect, btnOptions);
btnObserver.observe(btnArea);

